/**
 * @description
 */

import { fetchData } from '@umu/umu-fetch';

import Api from '../../../../path';
import { EPracticeQuestionStatus } from '@umu/umu-types';

export interface IInput {
    question_ids: string; // number[].join(',');
}

export interface IQuizQuestionStatus {
    id: number;
    status: EPracticeQuestionStatus;
}

export type IOutput = IQuizQuestionStatus[];

export const getQuestionStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
